import createNovedadTurnoForm from './createNovedadTurnoFormModel';
const {
  formField: {
    // DATOS PARAMETROS
    colaborador,
    responsable,
    tipoNovedad,
    fechaNovedad,
    horaNovedad,
    description,
  },
} = createNovedadTurnoForm;

export default {
  [colaborador.name]: '',
  [responsable.name]: '',
  [tipoNovedad.name]: '',
  [fechaNovedad.name]: null,
  [horaNovedad.name]: '',
  [description.name]: '',
};
